










import { Vue, Component } from 'vue-property-decorator';
import ContratosBase from '@/pantallas/SucursalVirtual/Contratos/ContratosBase.vue';

@Component({
  components: { ContratosBase },
})
export default class BajasComercialesPantalla extends Vue {}
